export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  reimbursed: "bg-indigo-50 text-indigo-700 border-indigo-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200 line-through",
};

import { useT } from "../i18n";

export const StatusPill = ({ status }) => {
  const { t } = useT();
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border capitalize ${STATUS_STYLES[status] || STATUS_STYLES.draft}`}
    >
      {t(`st_${status}`)}
    </span>
  );
};
